<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            x="25"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="35"
              viewBox="0 0 40 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_587_17906)">
                <path
                  d="M5.98169 10.5081L7.82299 3.75H20.177L22.0183 10.5081H5.98169Z"
                  fill="#242424"
                  stroke="url(#paint0_linear_587_17906)"
                  stroke-width="1.5"
                />
                <rect
                  x="22"
                  y="14.3516"
                  width="3"
                  height="6.19355"
                  rx="1"
                  fill="url(#paint1_linear_587_17906)"
                />
                <rect
                  x="3"
                  y="14.3516"
                  width="3"
                  height="6.19355"
                  rx="1"
                  fill="url(#paint2_linear_587_17906)"
                />
                <rect
                  x="4.75"
                  y="9.94531"
                  width="18.5"
                  height="6.75806"
                  rx="1.25"
                  fill="#242424"
                  stroke="url(#paint3_linear_587_17906)"
                  stroke-width="1.5"
                />
                <ellipse
                  cx="20.25"
                  cy="13.5794"
                  rx="1.25"
                  ry="1.29032"
                  fill="url(#paint4_linear_587_17906)"
                />
                <ellipse
                  cx="8.25"
                  cy="13.5794"
                  rx="1.25"
                  ry="1.29032"
                  fill="url(#paint5_linear_587_17906)"
                />
                <rect
                  x="13"
                  y="12.2891"
                  width="2.5"
                  height="2.58065"
                  fill="url(#paint6_linear_587_17906)"
                />
              </g>
              <g filter="url(#filter1_d_587_17906)">
                <path
                  d="M15.9817 18.7659L17.823 12.0078H30.177L32.0183 18.7659H15.9817Z"
                  fill="#242424"
                  stroke="url(#paint7_linear_587_17906)"
                  stroke-width="1.5"
                />
                <rect
                  x="32"
                  y="22.6094"
                  width="3"
                  height="6.19355"
                  rx="1"
                  fill="url(#paint8_linear_587_17906)"
                />
                <rect
                  x="13"
                  y="22.6094"
                  width="3"
                  height="6.19355"
                  rx="1"
                  fill="url(#paint9_linear_587_17906)"
                />
                <rect
                  x="14.75"
                  y="18.2031"
                  width="18.5"
                  height="6.75806"
                  rx="1.25"
                  fill="#242424"
                  stroke="url(#paint10_linear_587_17906)"
                  stroke-width="1.5"
                />
                <ellipse
                  cx="30.25"
                  cy="21.8372"
                  rx="1.25"
                  ry="1.29032"
                  fill="url(#paint11_linear_587_17906)"
                />
                <ellipse
                  cx="18.25"
                  cy="21.8372"
                  rx="1.25"
                  ry="1.29032"
                  fill="url(#paint12_linear_587_17906)"
                />
                <rect
                  x="23"
                  y="20.5469"
                  width="2.5"
                  height="2.58065"
                  fill="url(#paint13_linear_587_17906)"
                />
              </g>
              <path
                d="M5.98169 24.9612L7.82299 18.2031H20.177L22.0183 24.9612H5.98169Z"
                fill="#242424"
                stroke="url(#paint14_linear_587_17906)"
                stroke-width="1.5"
              />
              <rect
                x="22"
                y="28.8047"
                width="3"
                height="6.19355"
                rx="1"
                fill="url(#paint15_linear_587_17906)"
              />
              <rect
                x="3"
                y="28.8047"
                width="3"
                height="6.19355"
                rx="1"
                fill="url(#paint16_linear_587_17906)"
              />
              <rect
                x="4.75"
                y="24.3984"
                width="18.5"
                height="6.75806"
                rx="1.25"
                fill="#242424"
                stroke="url(#paint17_linear_587_17906)"
                stroke-width="1.5"
              />
              <ellipse
                cx="20.25"
                cy="28.0325"
                rx="1.25"
                ry="1.29032"
                fill="url(#paint18_linear_587_17906)"
              />
              <ellipse
                cx="8.25"
                cy="28.0325"
                rx="1.25"
                ry="1.29032"
                fill="url(#paint19_linear_587_17906)"
              />
              <rect
                x="13"
                y="26.7422"
                width="2.5"
                height="2.58065"
                fill="url(#paint20_linear_587_17906)"
              />
              <defs>
                <filter
                  id="filter0_d_587_17906"
                  x="0"
                  y="0"
                  width="30"
                  height="25.5469"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset
                    dx="1"
                    dy="1"
                  />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite
                    in2="hardAlpha"
                    operator="out"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.16 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_587_17906"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_587_17906"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d_587_17906"
                  x="10"
                  y="8.25781"
                  width="30"
                  height="25.5469"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset
                    dx="1"
                    dy="1"
                  />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite
                    in2="hardAlpha"
                    operator="out"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.16 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_587_17906"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_587_17906"
                    result="shape"
                  />
                </filter>
                <linearGradient
                  id="paint0_linear_587_17906"
                  x1="14"
                  y1="1.45161"
                  x2="14"
                  y2="11.2581"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.453569"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_587_17906"
                  x1="23.5"
                  y1="14.3516"
                  x2="23.5"
                  y2="20.5451"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.596875"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_587_17906"
                  x1="4.5"
                  y1="14.3516"
                  x2="4.5"
                  y2="20.5451"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.596875"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_587_17906"
                  x1="14"
                  y1="8.67918"
                  x2="14"
                  y2="17.4534"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.363475"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_587_17906"
                  x1="20.25"
                  y1="12.2891"
                  x2="20.25"
                  y2="14.8697"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_587_17906"
                  x1="8.25"
                  y1="12.2891"
                  x2="8.25"
                  y2="14.8697"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint6_linear_587_17906"
                  x1="14.25"
                  y1="12.2891"
                  x2="14.25"
                  y2="14.8697"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint7_linear_587_17906"
                  x1="24"
                  y1="9.70943"
                  x2="24"
                  y2="19.5159"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.453569"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint8_linear_587_17906"
                  x1="33.5"
                  y1="22.6094"
                  x2="33.5"
                  y2="28.8029"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.596875"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint9_linear_587_17906"
                  x1="14.5"
                  y1="22.6094"
                  x2="14.5"
                  y2="28.8029"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.596875"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint10_linear_587_17906"
                  x1="24"
                  y1="16.937"
                  x2="24"
                  y2="25.7112"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.363475"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint11_linear_587_17906"
                  x1="30.25"
                  y1="20.5469"
                  x2="30.25"
                  y2="23.1275"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint12_linear_587_17906"
                  x1="18.25"
                  y1="20.5469"
                  x2="18.25"
                  y2="23.1275"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint13_linear_587_17906"
                  x1="24.25"
                  y1="20.5469"
                  x2="24.25"
                  y2="23.1275"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint14_linear_587_17906"
                  x1="14"
                  y1="15.9047"
                  x2="14"
                  y2="25.7112"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.453569"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint15_linear_587_17906"
                  x1="23.5"
                  y1="28.8047"
                  x2="23.5"
                  y2="34.9982"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.596875"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint16_linear_587_17906"
                  x1="4.5"
                  y1="28.8047"
                  x2="4.5"
                  y2="34.9982"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.596875"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint17_linear_587_17906"
                  x1="14"
                  y1="23.1323"
                  x2="14"
                  y2="31.9065"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.363475"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint18_linear_587_17906"
                  x1="20.25"
                  y1="26.7422"
                  x2="20.25"
                  y2="29.3228"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint19_linear_587_17906"
                  x1="8.25"
                  y1="26.7422"
                  x2="8.25"
                  y2="29.3228"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
                <linearGradient
                  id="paint20_linear_587_17906"
                  x1="14.25"
                  y1="26.7422"
                  x2="14.25"
                  y2="29.3228"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.466667"
                    stop-color="#00B058"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>ปริมาณยานพาหนะทั้งหมด</strong>
            <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <a v-if="TotalCount !== 0">
              <b> {{ TotalCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} </b>
              <strong style="font-size: 20px;">คัน/วัน</strong>
            </a>
            <a v-if="TotalCount === 0">
              <b> 0 </b>
              <strong style="font-size: 20px;">คัน/วัน</strong>
            </a>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            x="25"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4ZM17.1667 19V11.6154H23L16 3L9 11.6154H14.8333V19H17.1667ZM7.87852 21.06H9.95852V27H11.3985V21.06H13.4785V20H7.87852V21.06ZM13.8262 26.41C14.2795 26.87 14.9095 27.1 15.7162 27.1C16.5228 27.1 17.1528 26.87 17.6062 26.41C18.0662 25.95 18.2962 25.3133 18.2962 24.5C18.2962 23.6867 18.0662 23.05 17.6062 22.59C17.1528 22.13 16.5228 21.9 15.7162 21.9C14.9095 21.9 14.2795 22.13 13.8262 22.59C13.3728 23.05 13.1462 23.6867 13.1462 24.5C13.1462 25.3133 13.3728 25.95 13.8262 26.41ZM16.6762 25.71C16.4428 26.0033 16.1228 26.15 15.7162 26.15C15.3095 26.15 14.9895 26.0033 14.7562 25.71C14.5295 25.4167 14.4162 25.0133 14.4162 24.5C14.4162 23.9867 14.5295 23.5833 14.7562 23.29C14.9895 22.9967 15.3095 22.85 15.7162 22.85C16.1228 22.85 16.4428 22.9967 16.6762 23.29C16.9095 23.5833 17.0262 23.9867 17.0262 24.5C17.0262 25.0133 16.9095 25.4167 16.6762 25.71ZM19.1072 22C19.1339 22.3467 19.1472 22.79 19.1472 23.33V29.42H20.4272V26.49H20.4572C20.5772 26.6833 20.7605 26.8333 21.0072 26.94C21.2539 27.0467 21.5372 27.1 21.8572 27.1C22.5105 27.1 23.0205 26.87 23.3872 26.41C23.7605 25.95 23.9472 25.3167 23.9472 24.51C23.9472 23.7033 23.7639 23.0667 23.3972 22.6C23.0305 22.1333 22.5305 21.9 21.8972 21.9C21.5705 21.9 21.2739 21.9667 21.0072 22.1C20.7405 22.2333 20.5239 22.42 20.3572 22.66H20.3372C20.3372 22.42 20.3272 22.2 20.3072 22H19.1072ZM22.3872 25.72C22.2005 26.0067 21.9305 26.15 21.5772 26.15C21.2505 26.15 20.9772 26.0433 20.7572 25.83C20.5372 25.61 20.4272 25.34 20.4272 25.02V23.99C20.4272 23.6567 20.5339 23.39 20.7472 23.19C20.9672 22.9833 21.2505 22.88 21.5972 22.88C22.3105 22.88 22.6672 23.41 22.6672 24.47C22.6672 25.01 22.5739 25.4267 22.3872 25.72Z"
                fill="url(#paint0_linear_587_17902)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_587_17902"
                  x1="16"
                  y1="0"
                  x2="16"
                  y2="32"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.260417"
                    stop-color="#F2B94A"
                  />
                  <stop
                    offset="1"
                    stop-color="#F2994A"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>ยานพาหนะสูงสุด</strong>
            <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div v-if="MaxCount !== 0">
              <span style="font-size: 24px; color: #F9E6BE;">{{ Type }} </span>
              <b>{{ MaxCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</b>
              <span style="font-size: 20px; color: #fff;"> คัน/วัน </span>
            </div>
            <div v-if="MaxCount === 0">
              <span style="font-size: 24px; color: #F9E6BE;">{{ Type }} </span>
              <b>0</b>
              <span style="font-size: 20px; color: #fff;"> คัน/วัน </span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/markeranalytic120\iconA120\accident.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>รถจอด / อุบัติเหตุ</strong>
            <!-- <em>word wrap</em> -->
            </div>
            <b-card-header style="margin-top: 10px; text-align: right;">
              <b-button
                id="toggle-btn"
                v-b-modal="'modalCarStop'"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                style="font-size: 14px;"
                title="Click to show more"
              >
                <span
                  class="align-middle"
                  style="color: #11DF00;"
                >
                  ดูเพิ่มเติม
                  <feather-icon
                    icon="ChevronsRightIcon"
                    size="14"
                  />
                </span>
              </b-button>
            </b-card-header>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="200"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ CarStop }} </b>
              <strong style="font-size: 20px;">คัน</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/markeranalytic120\iconA120\reverse.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>รถย้อนศร</strong>
            <!-- <em>word wrap</em> -->
            </div>
            <b-card-header style="margin-top: 10px; text-align: right;">
              <b-button
                id="toggle-btn"
                v-b-modal="'modalWrongWay'"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                style="font-size: 14px;"
                title="Click to show more"
              >
                <span
                  class="align-middle"
                  style="color: #11DF00;"
                >
                  ดูเพิ่มเติม
                  <feather-icon
                    icon="ChevronsRightIcon"
                    size="14"
                  />
                </span>
              </b-button>
            </b-card-header>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="200"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ WrongWay }} </b>
              <strong style="font-size: 20px;">คัน</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <ModalWrongWay />
    <ModalCarStop />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCardHeader, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import ModalWrongWay from '@/views/StatisModal/ModalWrongWay.vue'
import ModalCarStop from '@/views/StatisModal/ModalCarStop.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCardHeader,
    BButton,
    ModalWrongWay,
    ModalCarStop,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      Speed120: '',
      Speed90: '',
      CarStop: '',
      WrongWay: '',
      MaxCount: '',
      TotalCount: '',
      Type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getStaticDetail()
    this.getStaticAIDetail()
    this.interval = setInterval(() => {
      this.getStaticAIDetail()
      this.getStaticDetail()
    }, 300000)
  },
  methods: {
    getStaticAIDetail() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCheckTypeAITotal-G', { wid: this.$route.query.wid })
          .then(response => {
          // this.Speed120 = response.data[2][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          // this.Speed90 = response.data[1][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.CarStop = response.data[0][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.WrongWay = response.data[5][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.truckRight_len = response.data[4][0].Total
            this.Right_len = response.data[2][0].Total + response.data[3][0].Total + response.data[1][0].Total
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCheckTypeAITotal', { wid: this.$route.query.wid })
          .then(response => {
          // this.Speed120 = response.data[2][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          // this.Speed90 = response.data[1][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.CarStop = response.data[0][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.WrongWay = response.data[5][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.truckRight_len = response.data[4][0].Total
            this.Right_len = response.data[2][0].Total + response.data[3][0].Total + response.data[1][0].Total
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getStaticDetail() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getStaticAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.TotalCount = response.data[1][7].countNum
            this.MaxCount = response.data[1][4].countNum
            if (response.data[1][4].countNum === response.data[1][1].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'จักรยานยนต์'
            } else if (response.data[1][4].countNum === response.data[1][3].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถยนต์'
            } else if (response.data[1][4].countNum === response.data[1][9].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถบรรทุก'
            } else if (response.data[1][4].countNum === response.data[1][2].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถบัส'
            } else if (response.data[1][4].countNum === response.data[1][6].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถแท็กซี่'
            } else if (response.data[1][4].countNum === response.data[1][5].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถกระบะ'
            } else if (response.data[1][4].countNum === response.data[1][8].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถพ่วง'
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else if (this.$route.query.type === '0') {
        console.log(1234)
        axios
          .post('/getStaticAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.TotalCount = response.data[1][7].countNum
            this.MaxCount = response.data[1][4].countNum
            if (response.data[1][4].countNum === response.data[1][1].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'จักรยานยนต์'
            } else if (response.data[1][4].countNum === response.data[1][3].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถยนต์'
            } else if (response.data[1][4].countNum === response.data[1][9].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถบรรทุก'
            } else if (response.data[1][4].countNum === response.data[1][2].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถบัส'
            } else if (response.data[1][4].countNum === response.data[1][6].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถแท็กซี่'
            } else if (response.data[1][4].countNum === response.data[1][5].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถกระบะ'
            } else if (response.data[1][4].countNum === response.data[1][8].countNum && response.data[1][4].countNum !== 0) {
              this.Type = 'รถพ่วง'
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style scoped>
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  </style>
